"use client"
import {
  useStyle 
} from "@/classify"
import useFieldState from "@/common/hooks/hook-wrappers/useInformedFieldStateWrapper"
import {
  RadioGroup as InformedRadioGroup 
} from "informed"
import {
  Fragment 
} from "react"
import {
  Message 
} from "../Field"
import MyContext from "./MyContext"
import Radio from "./radio"
import defaultClasses from "./radioGroup.module.css"

const RadioGroup = (props) => {
  const {
    children,
    classes: propClasses,
    disabled,
    field,
    id,
    items,
    message,
    ...rest
  } = props
  const fieldState = useFieldState(field)
  const classes = useStyle(defaultClasses, propClasses)

  const {
    value: currentValue 
  } = fieldState || {}

  const value = {
    currentValue: currentValue 
  };


  const options =
        (<MyContext.Provider value={value}>
          {children}
        </MyContext.Provider>) ||
        items.map(({
          value, ...item 
        }) => (
          <Radio
            data-cy=''
            key={value}
            disabled={disabled}
            {...item}
            classes={{
              label: classes.radioLabel,
              root: classes.radioContainer,
            }}
            id={`${field}--${value}`}
            value={value}
          />
        ))

  return (
    <Fragment>
      <div className={classes.root}>
        <InformedRadioGroup {...rest} field={field} id={id}>
          {options}
        </InformedRadioGroup>
      </div>
      <Message className={classes.message} fieldState={fieldState}>
        {message}
      </Message>
    </Fragment>
  )
}

export default RadioGroup
